import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { toast } from "react-toastify";
import { get, patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const SpecialMmc = ({
  type,
  data,
  optionsList,
  setOfferEdit,
  handleFilter,
  mappedProperties,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderColor: state.isFocused ? "#333" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
      "&:hover": {
        borderColor: "#333",
      },
    }),
  };

  const initial_data = {
    name: data?.name ?? "",
    amount: data?.amount ?? "",
    gst: data?.gst ?? "",
    validity: data?.plan_days ?? "",
    total: data?.total_amount ?? "",
    freeValidity: data?.first_time_offer_days ?? "",
    id: data?.plan_id ?? "",
    planType: data?.planType ?? "",
    states: data?.states ?? [],
    hints: data?.terms_conditions ?? [],
    cities: data?.cities ?? [],
    properties: data?.properties ?? [],
  };
  const [planData, setPlanData] = useState(initial_data);
  const [options, setOptions] = useState({
    cities: [],
    properties: [],
  });
  const inputOptions = [
    {
      id: 1,
      title: "Plan Type",
      value: planData?.planType,
      accessor: "planType",
      type: "number",
      editable: type === "add",
      inputType: "Dropdown",
      isMultiple: false,
      options: optionsList?.plans,
    },
    {
      id: 2,
      title: "Subscription Amount",
      subTitle: "(Month)",
      value: planData?.amount,
      accessor: "amount",
      type: "number",
      editable: false,
    },
    {
      id: 3,
      title: "GST%",
      subTitle: "",
      value: planData?.gst,
      accessor: "gst",
      type: "number",
      editable: false,
    },
    {
      id: 4,
      title: "Plan Validity",
      subTitle: "(Days)",
      value: planData?.validity,
      accessor: "validity",
      type: "number",
      editable: false,
    },
    {
      id: 6,
      title: "Free Plan Validity",
      subTitle: "(Days)",
      value: planData?.freeValidity,
      accessor: "freeValidity",
      type: "number",
      editable: false,
    },
    {
      id: 7,
      title: "Plan ID",
      subTitle: "",
      value: planData?.id,
      accessor: "id",
      type: "text",
      editable: false,
    },
    {
      id: 5,
      title: "Total Amount",
      subTitle: "(Month)",
      value: planData?.total,
      accessor: "total",
      type: "number",
      editable: false,
    },
    {
      id: 8,
      title: "State",
      subTitle: "",
      value:
        optionsList?.states?.length !== 0 &&
        optionsList?.states?.length === planData?.states?.length
          ? [{ value: "All", label: "All" }]
          : planData?.states,
      accessor: "states",
      type: "text",
      inputType: "Dropdown",
      isMultiple: true,
      options: optionsList?.states,
      editable: true,
      selectAll: true,
      selectAll_val:
        optionsList?.states?.length !== 0 &&
        optionsList?.states?.length === planData?.states?.length,
    },
    {
      id: 9,
      title: "City",
      subTitle: "",
      value:
        options?.cities?.length !== 0 &&
        options?.cities?.length === planData?.cities?.length
          ? [{ value: "All", label: "All" }]
          : planData?.cities,
      accessor: "cities",
      type: "text",
      inputType: "Dropdown",
      isMultiple: true,
      options: options?.cities,
      editable: true,
      selectAll: true,
      selectAll_val:
        options?.cities?.length !== 0 &&
        options?.cities?.length === planData?.cities?.length,
    },
    {
      id: 10,
      title: "Property Name",
      subTitle: "",
      value:
        options?.properties?.length !== 0 &&
        options?.properties?.length === planData?.properties?.length
          ? [{ value: "All", label: "All" }]
          : planData?.properties,
      accessor: "properties",
      type: "text",
      inputType: "Dropdown",
      isMultiple: true,
      options: handleFilter(options?.properties, mappedProperties),
      editable: true,
      selectAll: true,
      selectAll_val:
        options?.properties?.length !== 0 &&
        options?.properties?.length === planData?.properties?.length,
    },
  ];

  const handleChange = (accessor, val) => {
    console.log("change called", accessor, val);
    if (accessor === "states") {
      getFilteredData(1, val);
      handleChange("cities", []);
      handleChange("properties", []);
      setOptions({ cities: [], properties: [] });
    }
    if (accessor === "cities") {
      getFilteredData(2, val);
      handleChange("properties", []);
      setOptions((prev) => ({ ...prev, properties: [] }));
    }
    if (accessor === "planType") {
      setPlanData((prev) => ({
        ...prev,
        name: val?.name ?? "",
        amount: val?.amount ?? "",
        gst: val?.gst ?? "",
        validity: val?.plan_days ?? "",
        total: val?.total_amount ?? "",
        freeValidity: val?.first_time_offer_days ?? "",
        id: val?.plan_id ?? "",
        hints: val?.terms_conditions,
      }));
    }
    setPlanData((prev) => ({
      ...prev,
      [accessor]: val,
    }));
  };

  const getFilteredData = async (type, val) => {
    if (!val || val?.length === 0) return;
    let payload = {
      [type === 1 ? "state_ids" : "city_ids"]: val?.map((item) => item?.value),
    };

    let res = await post(URLS.MMC_PROPERTIES_FILTER, payload);
    if (res?.status === "success") {
      console.log("options list", options);
      setOptions((prev) => ({
        ...prev,
        [type === 1 ? "cities" : "properties"]: res?.data?.map((item) => ({
          ...item,
          value: item?.id,
          label: item?.name,
        })),
      }));
    }
  };

  //api functions

  useEffect(() => {
    if (initial_data?.states?.length !== 0)
      getFilteredData(1, initial_data.states);
    if (initial_data?.cities?.length !== 0)
      getFilteredData(2, initial_data.cities);
  }, [initial_data.states, initial_data.cities]);

  const handleSubmit = async () => {
    if (!planData?.planType?.value) {
      toast.error("Please Select Plan");
      return;
    }
    if (planData?.properties?.length === 0) {
      toast.error("Please Select Atleaset one Property");
      return;
    }
    let res = await patch(`${URLS.MMC_PLANS}${planData?.planType?.value}/`, {
      property_ids: planData?.properties?.map((item) => item?.value),
    });
    if (res?.status === "success") {
      toast.success(res?.message);
      setOfferEdit(false);
    }
    // let res = await post()
  };

  return (
    <div className="row mt-4 mb-4">
      {/* inputs  */}
      {inputOptions.map((item, ind) => {
        return (
          <div key={ind} className="col-md-6 mb-3">
            <div className="d-flex ac-jb">
              <p className="f3 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16">
                {item.title}{" "}
                {item.subTitle && (
                  <span
                    className="f1 fs-sm-8 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                    style={{ color: "#9A36E6" }}
                  >
                    <i>{item.subTitle}</i>
                  </span>
                )}
              </p>
              {item?.selectAll && (
                <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                  <input
                    type="checkbox"
                    checked={item?.selectAll_val}
                    onChange={(e) =>
                      handleChange(
                        item.accessor,
                        item?.selectAll_val ? [] : item.options,
                      )
                    }
                    style={{
                      cursor: "pointer",
                      width: 18,
                      height: 18,
                      accentColor: "#A140E0",
                    }}
                  />
                  <p className="f2 fs-sm-8 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14">
                    Select All
                  </p>
                </div>
              )}
            </div>
            {item?.inputType === "Dropdown" ? (
              <Select
                options={item?.options ?? []}
                isMulti={item.isMultiple}
                value={item.value}
                onChange={(e) => {
                  handleChange(
                    item.accessor,
                    item?.selectAll_val
                      ? e.filter((item) => item?.value !== "All")
                      : e,
                  );
                }}
                className="mt-2 pt-1 pb-1"
                placeholder="Select"
                styles={customStyles}
                isDisabled={!item.editable}
              />
            ) : (
              <input
                name="userName"
                type={item.type}
                value={item.value}
                className={`input-box mt-2 ${item.editable ? "" : "cursor"}`}
                placeholder={`Enter ${item.title}`}
                disabled={!item.editable}
              />
            )}
          </div>
        );
      })}
      <div className="d-flex ac-js gap-3">
        <button onClick={handleSubmit} className="submit-btn mt-3 mb-3 ">
          Submit
        </button>

        <button
          onClick={() => setOfferEdit(false)}
          className="back-btn mt-3 mb-3 bg-white  rounded "
        >
          Back
        </button>
      </div>

      {/* details  */}
      {planData?.hints && planData?.hints?.length !== 0 && (
        <div style={{ backgroundColor: "#F3F4F6" }} className=" rounded p-3">
          <h5 className="f4">Plan Details</h5>
          <hr className="p-2" />
          <ul className="mt-2">
            {planData?.hints?.map((item, index) => (
              <li key={index} className="d-flex as-jb gap-3 mt-2">
                <div className="d-flex as-js gap-3">
                  <ReceiptLongOutlinedIcon
                    htmlColor="#A855F7"
                    fontSize="small"
                  />
                  <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16  text-start">
                    {item}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
export default SpecialMmc;
